import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "icon-drawer icon-drawer-teacher",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      class: "path-grid",
      d: "M9.25 18.75C9.71413 18.75 10.1592 18.5656 10.4874 18.2374C10.8156 17.9092 11 17.4641 11 17L11 3C11 2.53587 10.8156 2.09075 10.4874 1.76256C10.1593 1.43437 9.71413 1.25 9.25 1.25L1.375 1.25L1.375 18.75L9.25 18.75ZM3.125 11.75L3.125 8.25L9.25 8.25L9.25 11.75L3.125 11.75ZM3.125 6.5L3.125 3L9.25 3L9.25 6.5L3.125 6.5ZM3.125 17L3.125 13.5L9.25 13.5L9.25 17L3.125 17Z"
    }, null, -1),
    _createElementVNode("path", {
      class: "path-arrow",
      d: "M18.3334 9.99998L14.975 6.66665L14.975 9.16665L12.475 9.16665L12.475 10.8333L14.975 10.8333L14.975 13.3333L18.3334 9.99998Z"
    }, null, -1)
  ])))
}
export default { render: render }